module.exports = __webpack_public_path__ + "static/img/slider-1.d31582cc.png";